<script lang="ts">
  let props = $props()
  let { answer } = props
</script>

<div
  class="lg:ml-8 mt-2 border-l-2 border-dashed border-blue-800 px-4 lg:px-6 py-3 lg:py-6 bg-sky-50 rounded-r"
>
  {#if answer == 1}
    <p class="text-base lg:text-xl/8 text-gray-700">
      A: <span class="font-bold">“Above 90”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This suggests high alignment - people are connected to the mission and
      energized by the culture.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      A crew that believes in the mission pushes harder, collaborates faster,
      and adapts better.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Ask: <span class="italic"
        >What’s driving that score - and how are we protecting it?
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Celebrate the strength, but make sure it’s being converted into clear
      execution.
    </p>
  {:else if answer == 2}
    <p class="text-base lg:text-xl/8 text-gray-700">
      B: <span class="font-bold">“Above 50” </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      You’ve got pockets of engagement - but it’s uneven.
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      Some teams may feel aligned, others disconnected or unclear on the bigger
      picture.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      This is like a submarine where some compartments are running drills and
      others are drifting.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Dig deeper into the data. Ask: <span class="italic"
        >Where’s the energy - and where’s the silence?</span
      >
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Use that insight to target alignment conversations by function or team.
    </p>
  {:else if answer == 3}
    <p class="text-base lg:text-xl/8 text-gray-700">
      C: <span class="font-bold">“Have not done in the last 6 months.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      You’re flying without a dashboard. It’s hard to steer a crew if you don’t
      know how they’re doing.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      A Fast Attack leader checks vital signs regularly - not after the damage
      is done.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Run a lightweight pulse check this quarter. Even 3–4 questions can reveal
      if your team is aligned, clear, and energized - or just surviving.
    </p>
  {:else if answer == 4}
    <p class="text-base lg:text-xl/8 text-gray-700">
      D: <span class="font-bold">“We don’t regularly survey employees.” </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This suggests that alignment and engagement aren’t being measured - or
      prioritized.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Flying blind on crew morale and clarity means you’re one disruption away
      from a major issue - and you won’t see it coming.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Start now. Even informal feedback loops can surface gaps.
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Ask: <span class="italic"
        >What’s one thing we can do this month to check alignment and energy
        across the team?</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Readiness starts with awareness.
    </p>
  {/if}
</div>
